import React from 'react'
import { Autocomplete, Chip, TextField } from '@mui/material'

/**
 * Specific-duration buckets slicer (Thibault's "checkboxes (1, 2, 3, 4…)").
 *
 * Composes with Short/Long: pick one or several buckets to narrow the
 * universe further than the broad Short/Long chip. Empty selection =
 * no extra filter.
 *
 * Buckets emitted to the backend:
 *   '1', '2', '3', '4', '5', '6', '7'      → exact days
 *   '8-14', '15-29'                        → BETWEEN
 *   '30+'                                  → >= N
 *
 *   value     = string[]
 *   onChange(value, { intent: 'pending' })
 *
 * Pending intent (not instant): user typically picks several buckets
 * before applying. The Apply button counts the pending change.
 */
const OPTIONS = ['1', '2', '3', '4', '5', '6', '7', '8-14', '15-29', '30+']

const PRETTY = {
	'1':     '1 day',
	'2':     '2 days',
	'3':     '3 days',
	'4':     '4 days',
	'5':     '5 days',
	'6':     '6 days',
	'7':     '7 days',
	'8-14':  '8–14 days',
	'15-29': '15–29 days',
	'30+':   '30+ days',
}

export default function DaysBucketsSlicer({ value, onChange }) {
	return (
		<Autocomplete
			multiple
			size="small"
			options={OPTIONS}
			value={value || []}
			onChange={(_, v) => onChange(v, { intent: 'pending' })}
			getOptionLabel={(o) => PRETTY[o] || o}
			renderTags={(values, getTagProps) =>
				values.map((v, i) => (
					<Chip variant="outlined" size="small"
					      label={PRETTY[v] || v}
					      {...getTagProps({ index: i })}/>
				))
			}
			renderInput={(params) => (
				<TextField {...params} InputLabelProps={{ ...params.InputLabelProps, shrink: true }} label="Days"
				           placeholder={value?.length ? '' : 'Any'}/>
			)}
			sx={{ minWidth: 220, maxWidth: 360 }}
		/>
	)
}
